import { Phone, CalendarCheck, UtensilsCrossed, Pizza, Bike } from "lucide-react";
import { Link } from "react-router-dom";

const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const MobileActionBar = ({ restaurant }) => {
  if (restaurant) {
    return (
      <div
        data-testid="mobile-action-bar"
        className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-[#121110]/90 px-4 pt-3 backdrop-blur-xl lg:hidden"
        style={{ paddingBottom: "max(env(safe-area-inset-bottom), 0.75rem)" }}
      >
        <div className="flex gap-3">
          <a
            href={restaurant.phone_link}
            data-testid="mobile-call-button"
            className="flex flex-1 items-center justify-center gap-2 rounded-full bg-red-600 py-3.5 text-sm font-bold text-white active:bg-red-500"
          >
            <Phone className="h-4 w-4" /> Sună: {restaurant.phone}
          </a>
          <button
            onClick={() => scrollToId("rezervari")}
            data-testid="mobile-reserve-button"
            className="flex flex-1 items-center justify-center gap-2 rounded-full border border-stone-600 py-3.5 text-sm font-bold text-stone-100 active:bg-stone-800"
          >
            {restaurant.delivery_note ? <Bike className="h-4 w-4" /> : <CalendarCheck className="h-4 w-4" />}
            {restaurant.delivery_note ? " Comandă acasă" : " Rezervă masă"}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      data-testid="mobile-action-bar"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-[#121110]/90 px-4 pt-3 backdrop-blur-xl lg:hidden"
      style={{ paddingBottom: "max(env(safe-area-inset-bottom), 0.75rem)" }}
    >
      <div className="flex gap-3">
        <Link
          to="/zoo"
          data-testid="mobile-goto-zoo"
          className="flex flex-1 items-center justify-center gap-2 rounded-full bg-red-600 py-3.5 text-sm font-bold text-white active:bg-red-500"
        >
          <UtensilsCrossed className="h-4 w-4" /> La Zoo
        </Link>
        <Link
          to="/unirii"
          data-testid="mobile-goto-unirii"
          className="flex flex-1 items-center justify-center gap-2 rounded-full border border-stone-600 py-3.5 text-sm font-bold text-stone-100 active:bg-stone-800"
        >
          <Pizza className="h-4 w-4" /> La Unirii
        </Link>
      </div>
    </div>
  );
};
